import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { voucherList } from "../../../../controllers/V1/promocodes/promocodeController";
import Loading from "../../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from 'moment';
import { formatProjectDate } from "../../../../controllers/common";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
      const today = new Date();
      let from_date = formData.get('from_date');
      let to_date = formData.get('to_date');

      if(from_date && !to_date){
        to_date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
      }
      const option = {
        isExport : true,
        condition: {
          ...(formData.get("order_no") && { order_no: formData.get("order_no") } ),

          ...(formData.get("buyer_first_name") && { buyer_first_name: { $regex: formData.get("buyer_first_name"), $options: "i" } } ),
          ...(formData.get("buyer_last_name") && { buyer_last_name: { $regex: formData.get("buyer_last_name"), $options: "i" } } ),
          ...(formData.get("buyer_mobile") && { buyer_mobile: parseInt(formData.get("buyer_mobile")) } ),

          ...(formData.get("seller_first_name") && { seller_first_name: { $regex: formData.get("seller_first_name"), $options: "i" } } ),
          ...(formData.get("seller_last_name") && { seller_last_name: { $regex: formData.get("seller_last_name"), $options: "i" } } ),
          ...(formData.get("seller_mobile") && { seller_mobile: parseInt(formData.get("seller_mobile")) } ),

          ...(formData.get("voucher_number") && { voucher_number: parseInt(formData.get("voucher_number")) } ),
          ...(formData.get("points") && { points: parseInt(formData.get("points")) } ),
          ...(formData.get("redeem_order_no") && { redeem_order_no: formData.get("redeem_order_no") } ),
          ...(formData.get("status") && { status: { $regex: formData.get("status"), $options: "i" } } ),
          ...(formData.get("redeemed_date") && { redeemed_date: { $gte: `${formData.get("redeemed_date")} 00:00:00`, $lte : `${formData.get("redeemed_date")} 23:59:59` } } ),
          
          ...((from_date && to_date) && {createdAt : {$gte : `${from_date} 21:30:59`, $lte : `${to_date} 21:29:59`}  }),
        },
        select: {
          ...(formData.get("select_order_no") && { order_no: true } ),

          ...(formData.get("select_buyer_first_name") && { buyer_first_name: true } ),
          ...(formData.get("select_buyer_last_name") && { buyer_last_name: true } ),
          ...(formData.get("select_buyer_mobile") && { buyer_mobile: true } ),

          ...(formData.get("select_seller_first_name") && { seller_first_name: true } ),
          ...(formData.get("select_seller_last_name") && { seller_last_name: true } ),
          ...(formData.get("select_seller_mobile") && { seller_mobile: true } ),

          ...(formData.get("select_voucher_number") && { voucher_number: true } ),
          ...(formData.get("select_points") && { points: true } ),
          ...(formData.get("select_status") && { status: true } ),
          ...(formData.get("select_redeem_order_no") && { redeem_order_no: true } ),
          ...(formData.get("select_redeemed_date") && { redeemed_date: true } ),
          ...(formData.get("select_createdAt") && { createdAt: true } ),
          ...(formData.get("select_expiry_date") && { expiry_date: true } ),
        },
        sort : {createdAt : -1, redeemed_date : -1}
      };

      // Make the API call
      const res = await voucherList(option);
      if (res.status === true) {
        if(res?.result?.length > 0){
          let modifiedData = res?.result.map(({ _id, voucher_number,redeemed_date,createdAt,expiry_date, status, ...rest }) => ({ 
            ...rest,
            ...(status && {status : status === "A"?"Active":status}),
            ...(redeemed_date && {"Redeem Date" :  moment(formatProjectDate(redeemed_date)).format('DD-MM-YYYY HH:mm')}),
            ...(expiry_date && {"Expiry Date" :  moment(expiry_date).format('DD-MM-YYYY')}),
            ...(createdAt && {"Created Date" :  moment(formatProjectDate(createdAt)).format('DD-MM-YYYY HH:mm')}),
            'Vouchers': voucher_number
          }));
          await exportToExcel(modifiedData);
        }
        handleCancel(); // Reset the form or close modal
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    }
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `B-Winn Voucher's List ${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const [checkedData, setCheckedData] = useState({});
  const handleChecked = (e) =>{
    try {
      const {name, value} = e.target;
      setCheckedData((prev)=>({
        ...prev,
        [name] : prev[name] === "Y" ? "N" : "Y",
      }))
    } catch (error) {
      
    }
  }

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Export Vouchers
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="order_no" className="all_lable_for_vendor_dashbaord">Order No :</label>
                    <input type="text" name="order_no" id="order_no" placeholder="Order No" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="voucher_number" className="all_lable_for_vendor_dashbaord">Voucher's Number :</label>
                    <input type="text" name="voucher_number" id="voucher_number" placeholder="Voucher's Number" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="points" className="all_lable_for_vendor_dashbaord">Points :</label>
                    <input type="text" name="points" id="points" placeholder="Voucher's Number" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_first_name" className="all_lable_for_vendor_dashbaord">Buyer's First Name :</label>
                    <input type="text" name="buyer_first_name" id="buyer_first_name" placeholder="Buyer's First Name" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_last_name" className="all_lable_for_vendor_dashbaord">Buyer's Last Name :</label>
                    <input type="text" name="buyer_last_name" id="buyer_last_name" placeholder="Buyer's Last Name" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_mobile" className="all_lable_for_vendor_dashbaord">Buyer's Mobile :</label>
                    <input type="text" name="buyer_mobile" id="buyer_mobile" placeholder="Buyer's Mobile" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="seller_first_name" className="all_lable_for_vendor_dashbaord">Seller's First Name :</label>
                    <input type="text" name="seller_first_name" id="seller_first_name" placeholder="Seller's First Name" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="seller_last_name" className="all_lable_for_vendor_dashbaord">Seller's Last Name :</label>
                    <input type="text" name="seller_last_name" id="seller_last_name" placeholder="Seller's Last Name" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="seller_mobile" className="all_lable_for_vendor_dashbaord">Seller's Mobile :</label>
                    <input type="text" name="seller_mobile" id="seller_mobile" placeholder="Seller's Mobile" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="redeem_order_no" className="all_lable_for_vendor_dashbaord">Redeem order no. :</label>
                    <input type="text" name="redeem_order_no" id="redeem_order_no" placeholder="Redeem order no." className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="redeemed_date" className="all_lable_for_vendor_dashbaord">Redeem date. :</label>
                    <input type="date" name="redeemed_date" id="redeemed_date" placeholder="Redeem order no." className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="status" className="all_lable_for_vendor_dashbaord" > Order's Status : </label>
                    <select name="status" id="status" className="form-control categories_select_tg_enter_product">
                      <option value='A' selected >Active</option>
                      <option value='Redeem' >Redeem</option>
                      <option value=''>All</option>
                    </select>
                  </div>
                  
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="select_name" className="all_lable_for_vendor_dashbaord" > Date specific (If any) : </label>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="from_date" className="all_lable_for_vendor_dashbaord">From :</label>
                    <input type="date" name="from_date" id="from_date" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="to_date" className="all_lable_for_vendor_dashbaord">To :</label>
                    <input type="date" name="to_date" id="to_date" className="form-control categories_select_tg_enter_product" />
                  </div>

                  {/* Selection Checkboxes for Export */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="select_name" className="all_lable_for_vendor_dashbaord"> Export fields (If any) : </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_order_no" className="all_lable_for_vendor_dashbaord" > 
                        <input 
                          type="checkbox" 
                          name="select_order_no"
                          id="select_order_no" 
                          className="form-check-input" 
                          checked={checkedData?.select_order_no !== "Y" ? true : false} 
                          onClick={handleChecked} /> 
                          Order No.
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_buyer_first_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_buyer_first_name" id="select_buyer_first_name" className="form-check-input" checked={checkedData?.select_buyer_first_name !== "Y" ? true : false} onClick={handleChecked} /> Buyer's First Name
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_buyer_last_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_buyer_last_name" id="select_buyer_last_name" className="form-check-input" checked={checkedData?.select_buyer_last_name !== "Y" ? true : false} onClick={handleChecked} /> Buyer's Last Name
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_buyer_mobile" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_buyer_mobile" id="select_buyer_mobile" className="form-check-input" checked={checkedData?.select_buyer_mobile !== "Y" ? true : false} onClick={handleChecked} /> Buyer's Mobile
                      </label>
                    </div>
                    
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_seller_first_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_seller_first_name" id="select_seller_first_name" className="form-check-input" checked={checkedData?.select_seller_first_name !== "Y" ? true : false} onClick={handleChecked} /> Seller's First Name
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_seller_last_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_seller_last_name" id="select_seller_last_name" className="form-check-input" checked={checkedData?.select_seller_last_name !== "Y" ? true : false} onClick={handleChecked} /> Seller's Last Name
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_seller_mobile" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_seller_mobile" id="select_seller_mobile" className="form-check-input" checked={checkedData?.select_seller_mobile !== "Y" ? true : false} onClick={handleChecked} /> Seller's Mobile
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_voucher_number" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_voucher_number" id="select_voucher_number" className="form-check-input" checked={checkedData?.select_voucher_number !== "Y" ? true : false} onClick={handleChecked} /> Promo Code
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_points" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_points" id="select_points" className="form-check-input" checked={checkedData?.select_points !== "Y" ? true : false} onClick={handleChecked} /> Points
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_redeem_order_no" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_redeem_order_no" id="select_redeem_order_no" className="form-check-input" checked={checkedData?.select_redeem_order_no !== "Y" ? true : false} onClick={handleChecked} /> Redeem order no.
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_redeemed_date" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_redeemed_date" id="select_redeemed_date" className="form-check-input" checked={checkedData?.select_redeemed_date !== "Y" ? true : false} onClick={handleChecked} /> Redeemed date
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_expiry_date" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_expiry_date" id="select_expiry_date" className="form-check-input" checked={checkedData?.select_expiry_date !== "Y" ? true : false} onClick={handleChecked} /> Expiry Date
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_createdAt" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_createdAt" id="select_createdAt" className="form-check-input" checked={checkedData?.select_createdAt !== "Y" ? true : false} onClick={handleChecked} /> Created Date
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_status" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_status" id="select_status" className="form-check-input" checked={checkedData?.select_status !== "Y" ? true : false} onClick={handleChecked} /> Status
                      </label>
                    </div>
                    
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
